import React from 'react';
import { WidgetId } from '../../../../api/useWidgetsQuery';
import { ActivitySummaryCard } from '../../widgets/ActivitySummaryCard/ActivitySummaryCard';
import { AssetAllocationCard } from '../../widgets/AssetAllocationCard/AssetAllocationCard';
import { IncomeDetailsCard } from '../../widgets/IncomeDetailsCard/IncomeDetailsCard';
import { MarketValueCard } from '../../widgets/MarketValueCard/MarketValueCard';
import { PerformanceChartCard } from '../../widgets/PerformanceChartCard/PerformanceChartCard';
import { PerformanceDetailsCard } from '../../widgets/PerformanceDetailsCard/PerformanceDetailsCard';
import { PerformanceSummaryCard } from '../../widgets/PerformanceSummaryCard/PerformanceSummaryCard';
import { PerformanceVsBenchmarkCard } from '../../widgets/PerformanceVsBenchmarkCard/PerformanceVsBenchmarkCard';
import { PeriodReturnCard } from '../../widgets/PeriodReturnCard/PeriodReturnCard';
import { ProjectedIncomeCard } from '../../widgets/ProjectedIncomeCard/ProjectedIncomeCard';
import { RealizedGainLossDetailCard } from '../../widgets/RealizedGainLossDetailCard/RealizedGainLossDetailCard';
import { RealizedGainLossSummaryCard } from '../../widgets/RealizedGainLossSummaryCard/RealizedGainLossSummaryCard';
import { UnrealizedGainLossDetailCard } from '../../widgets/UnrealizedGainLossDetailCard/UnrealizedGainLossDetailCard';
import { UnrealizedGainLossSummaryCard } from '../../widgets/UnrealizedGainLossSummaryCard/UnrealizedGainLossSummaryCard';
import { ValueVsInvestmentCard } from '../../widgets/ValueVsInvestmentCard/ValueVsInvestmentCard';

interface Props {
  id: WidgetId;
  title: string;
}

export const WidgetContent = ({ id, title }: Props) => {
  if (id === 'market-value') {
    return <MarketValueCard />;
  }

  if (id === 'return') {
    return <PeriodReturnCard />;
  }

  if (id === 'activity-summary') {
    return <ActivitySummaryCard title={title} />;
  }

  if (id === 'pv-vs-nai') {
    return <ValueVsInvestmentCard title={title} />;
  }

  if (id === 'allocation-slot-a') {
    return <AssetAllocationCard tab="left" />;
  }

  if (id === 'allocation-slot-b') {
    return <AssetAllocationCard tab="right" />;
  }

  if (id === 'performance-summary') {
    return <PerformanceSummaryCard title={title} />;
  }

  if (id === 'performance-vs-benchmark') {
    return <PerformanceVsBenchmarkCard />;
  }

  if (id === 'performance-details') {
    return <PerformanceDetailsCard title={title} id={id} />;
  }

  if (id === 'projected-income') {
    return <ProjectedIncomeCard title={title} />;
  }

  if (id === 'income-details') {
    return <IncomeDetailsCard title={title} id={id} />;
  }

  if (id === 'performance-chart') {
    return <PerformanceChartCard title={title} id={id} />;
  }

  if (id === 'unrealized-gainloss-summary') {
    return <UnrealizedGainLossSummaryCard title={title} />;
  }

  if (id === 'unrealized-gainloss-detail') {
    return <UnrealizedGainLossDetailCard title={title} />;
  }

  if (id === 'realized-gainloss-summary') {
    return <RealizedGainLossSummaryCard title={title} />;
  }

  if (id === 'realized-gainloss-detail') {
    return <RealizedGainLossDetailCard title={title} />;
  }

  return null;
};
